import React from "react";
import { useState, useEffect } from "react";
import {
    Grid,
    Container,
    Typography,
    FormControl,
    Paper,
    InputBase,
    InputAdornment,
    TextField,
    Button,
    CircularProgress
} from "@material-ui/core";
import Menu from "@mui/material/Menu";
import moment from "moment";
import { alpha } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import TableHead from "@mui/material/TableHead";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@material-ui/icons/Clear";
import IconButton from "@mui/material/IconButton";
import DatePicker from "react-multi-date-picker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { connect } from "react-redux";
import { getActivityList, downloadActivityLogs } from "./actions/activityLogs";
import { formatDate } from "../../../common/components/Helper/Utils";
import { SpinnerRoundFilled } from "spinners-react";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));
const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));
const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === "light"
                ? "rgb(55, 65, 81)"
                : theme.palette.grey[300],
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": {
            padding: "4px 0",
        },
        "& .MuiMenuItem-root": {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            "&:active": {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
}));

const useStyles = makeStyles((theme) => ({
    sortIcon: {
        fontSize: "1rem",
        verticalAlign: "middle",
        cursor: "pointer",
    },
}));

const columns = [
    { id: "Team", label: "Team Member", minWidth: 100 },
    { id: "date", label: "Date", minWidth: 100 },
    {
        id: "event",
        label: "Event",
        minWidth: 100,
    },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const ActivityLogsComponent = (props) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [shippingDateValue, setShippingDateValue] = useState([]);
    const [selectedShippingDate, setSelectedShippingDate] = useState([]);
    const [inventoryId, setInventoryId] = useState("Inventory ID");
    const [invoiceId, setInvoiceId] = useState("Invoice ID");
    const [memoId, setMemoId] = useState("Memo No : MO");
    const [data, setData] = useState([]);
    const [loader, setloader] = useState(true);
    const accountId = window.sessionStorage.getItem('accountId');
    const [downloadLoading,setDownloadLoading] = useState(false)
    const handleDataCallback = (response) => {
        setData(response.data);
        setloader(false);
    };

    useEffect(() => {
        setloader(true);
        const userDetails = window.sessionStorage.getItem("userDetails")
            ? JSON.parse(window.sessionStorage.getItem("userDetails"))
            : null;
        const databoardObject = {
            accountid: accountId,
            name: searchKeyword.trim() || null,
        };
        if (selectedShippingDate && selectedShippingDate.length === 2) {
            databoardObject["activityDateInterval"] = {
                from: selectedShippingDate[0].format(),
                to: selectedShippingDate[1].format(),
            };
        }
        props.getActivityList(databoardObject, handleDataCallback);
    }, [selectedShippingDate]);

    useEffect(() => {
        if (shippingDateValue && shippingDateValue.length === 2) {
            setSelectedShippingDate(shippingDateValue);
        }
        if (
            shippingDateValue.length === 0 &&
            selectedShippingDate &&
            selectedShippingDate.length === 2
        ) {
            setSelectedShippingDate([]);
        }
    }, [shippingDateValue]);

    const fetchUsersGrid = (from = null) => {
        setloader(true);
        const dashboardData = {
            accountid: accountId,
            name: from === "clear" ? "" : searchKeyword.trim(),
        };
        if (shippingDateValue && shippingDateValue.length === 2) {
            dashboardData["activityDateInterval"] = {
                from: shippingDateValue[0].format(),
                to: shippingDateValue[1].format(),
            };
        }
        setPage(0);
        props.getActivityList(dashboardData, handleDataCallback);
    };

    const onSearchClick = (event) => {
        setSearchKeyword(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleEnterEvent = (event) => {
        if (event.key == "Enter") {
            event.preventDefault();
            fetchUsersGrid();
        }
    };

    const handleDownload = async () => {
     setDownloadLoading(true);
        const payload = {
            accountid: accountId,
            name: searchKeyword.trim() || null,
        };
        if (shippingDateValue && shippingDateValue.length === 2) {
            payload["activityDateInterval"] = {
            from: shippingDateValue[0].format("YYYY/MM/DD"),
            to: shippingDateValue[1].format("YYYY/MM/DD"),
            };
        }

        try {
            const res = await downloadActivityLogs(payload);
            setDownloadLoading(false);

            if (res?.status === 1) {
            } else {
            alert(res?.message || "Download failed");
            }
        } catch (error) {
            setDownloadLoading(false);
            alert("Download failed");
        }
    };

    const endAdornment = () => {
        const values = searchKeyword;
        if (values) {
            return (
                <InputAdornment position="end">
                    <IconButton
                        onClick={handleClearButton}
                        onMouseDown={handleMouseDown}
                        color="primary"
                    >
                        <ClearIcon />
                    </IconButton>
                    <IconButton
                        className="primary-bg color-white"
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                        onClick={fetchUsersGrid}
                    >
                        <SearchIcon />
                    </IconButton>
                </InputAdornment>
            );
        } else {
            return (
                <InputAdornment position="end">
                    <IconButton
                        className="primary-bg color-white"
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                        onClick={fetchUsersGrid}
                    >
                        <SearchIcon />
                    </IconButton>
                </InputAdornment>
            );
        }
    };
    const handleClearButton = () => {
        setSearchKeyword("");
        fetchUsersGrid("clear");
    };

    const handleMouseDown = (event) => {
        event.preventDefault();
    };
    function CustomInput({ onFocus, value, onChange }) {
        return (
            <TextField
                id="outlined-basic"
                label="Activity Date"
                style={{ width: "100%" }}
                variant="outlined"
                onFocus={onFocus}
                placeholder="from YYYY/MM/DD to YYYY/MM/DD"
                onPaste={(event) => event.preventDefault()}
                value={value}
                onChange={onChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <CalendarMonthIcon />
                        </InputAdornment>
                    ),
                }}
            />
        );
    }

    return (
        <div className="space-bottom-30 someextrahight">
            <Container>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={10}>
                        <Typography variant="h6">
                            <b>Activity Logs</b>
                        </Typography>
                    </Grid>
                       <Grid item xs={12} md={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            className="text-capitalize primary-bg color-white"
                            onClick={handleDownload}
                            style={{ height: "38px", marginRight: "10px" }}
                            disabled={downloadLoading}
                            endIcon={
                            downloadLoading ? (
                                <CircularProgress style={{ width: 22, height: 22, color: "#fff" }} />
                            ) : null
                            }
                        >
                            DOWNLOAD
                        </Button>
                     </Grid> 
                    <Grid item xs={12} md={5}>
                        <DatePicker
                            range
                            render={<CustomInput />}
                            value={shippingDateValue}
                            style={{  }}
                            containerStyle={{ display: "block" }}
                            onChange={(dateObjects) => {
                                setShippingDateValue(dateObjects);
                            }}
                            rangeHover
                            dateSeparator=" to "
                            plugins={[<DatePanel />]}
                        />
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <FormControl className="form-width-100">
                            <div style={{ marginLeft: "5px" }}>
                                <Paper
                                    component="form"
                                    sx={{ p: "2px 0px" }}
                                    style={{ height: "55px", display: "flex", width: "100%" }}
                                >
                                    <InputBase
                                        //   sx={{ ml: 1, flex: 1 }}
                                        fullWidth
                                        placeholder="Search by Name / Email / Inventory ID / Invoice ID / Memo ID"
                                        style={{
                                            flex: 1,
                                            marginLeft: "40px",
                                        }}
                                        inputProps={{
                                            "aria-label": "Search by Name / Email / Inventory ID / Invoice ID / Memo ID",
                                        }}
                                        onChange={(e) => {
                                            onSearchClick(e);
                                        }}
                                        onKeyPress={handleEnterEvent}
                                        value={searchKeyword}
                                        endAdornment={endAdornment()}
                                    />
                                </Paper>
                            </div>
                        </FormControl>
                        </Grid>
                    {loader ? (
                        <div className="d-spinner">
                            <SpinnerRoundFilled
                                size={51}
                                thickness={125}
                                speed={80}
                                color="rgba(57, 107, 172, 1)"
                                className="spp"
                                enabled={loader}
                            />
                        </div>
                    ) : (
                        <Grid item xs={12}>
                            <Paper style={{ width: "100%", overflow: "hidden" }}>
                                <TableContainer>
                                    <Table aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column) => (
                                                    <StyledTableCell key={column.id} align={column.align}>
                                                        {column.label}
                                                    </StyledTableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data && data.length ? (
                                                <>
                                                    {data
                                                        .slice(
                                                            page * rowsPerPage,
                                                            page * rowsPerPage + rowsPerPage
                                                        )
                                                        .map((row) => {
                                                            return (
                                                                <TableRow
                                                                    hover
                                                                    role="checkbox"
                                                                    tabIndex={-1}
                                                                    key={row.code}
                                                                >
                                                                    {columns.map((column) => {
                                                                        const value = row;
                                                                        // console.log(row);
                                                                        
                                                                        return (
                                                                            <>
                                                                                {column.id === "Team" && (
                                                                                    <>
                                                                                        <StyledTableCell>
                                                                                            <b>{row.username}</b> <br></br>
                                                                                            {row.email}
                                                                                        </StyledTableCell>
                                                                                    </>
                                                                                )}
                                                                                {column.id === "date" && (
                                                                                    <>
                                                                                        <StyledTableCell>
                                                                                            {/* {row.createdon
                                                                                            ? moment(row.createdon).format(
                                                                                                "MM/DD/YYYY hh:mm:ss"
                                                                                            )
                                                                                            : ""} */}
                                                                                           {row.createdon
                                                                                            ? moment.utc(row.createdon).local().format("MM/DD/YYYY HH:mm:ss")
                                                                                            : ""}
                                                                                        </StyledTableCell>
                                                                                    </>
                                                                                )}
                                                                             {column.id === "event" && (
                                                                            <StyledTableCell>
                                                                                {/* {row.events}
                                                                                {row.eventmemoid && (
                                                                                    <>
                                                                                        {" "} - <b>{memoId}{row.eventmemoid}</b>
                                                                                    </>
                                                                                )}
                                                                                {row.eventinvoiceid && (
                                                                                    <>
                                                                                        {" "} - <b>{invoiceId} {row.eventinvoiceid}</b>
                                                                                    </>
                                                                                )}
                                                                                {row.eventinventoryid && (
                                                                                    <>
                                                                                        {" "} and <b>{inventoryId} {row.eventinventoryid}</b>
                                                                                    </>
                                                                                )} */}
                                                                                {row.events}

                                                                                {(() => {
                                                                                   const eventName = (row.events || "").toLowerCase();     
                                                                                    if (eventName.includes("create new invoice")) {
                                                                                        return (
                                                                                                                                                                                    <>
                                                                                                {row.eventinvoiceid && (
                                                                                                    <> - <b>{invoiceId} {row.eventinvoiceid}</b></>
                                                                                                )}

                                                                                                {row.eventinvoiceid && row.eventinventoryid && " and "}

                                                                                                {row.eventinventoryid && (
                                                                                                    <> <b>{inventoryId} {row.eventinventoryid}</b></>
                                                                                                )}
                                                                                                </>
                                                                                        );
                                                                                    }
                                                                                       if (eventName.includes("create invoice payment details") || eventName.includes("void invoice payment") || eventName.includes("void payment") || eventName.includes("edit invoice payment") || eventName.includes("edit payment")) {
                                                                                        return (
                                                                                                                                                                                    <>
                                                                                                {row.eventinvoiceid && (
                                                                                                    <> - <b>{invoiceId} {row.eventinvoiceid}</b></>
                                                                                                )}

                                                                                                {row.eventinvoiceid && row.eventinventoryid && " and "}

                                                                                                {row.eventinventoryid && (
                                                                                                    <> <b>{inventoryId} {row.eventinventoryid}</b></>
                                                                                                )}
                                                                                                </>
                                                                                        );
                                                                                    }                                                  

                                                                                    if (eventName.includes("convert memo to invoice")) {
                                                                                        return (
                                                                                            <>
                                                                                                {/* {row.eventmemoid && (
                                                                                                    <> - <b>{memoId}{row.eventmemoid}</b></>
                                                                                                )} */}
                                                                                                {row.eventinvoiceid && (
                                                                                                    <> - <b>{invoiceId} {row.eventinvoiceid}</b></>
                                                                                                )}
                                                                                            </>
                                                                                        );
                                                                                    }

                                                                                    if (eventName.includes("memo closed")) {
                                                                                        return (
                                                                                            row.eventmemoid && (
                                                                                                <> - <b>{memoId}{row.eventmemoid}</b></>
                                                                                            )
                                                                                        );
                                                                                    }

                                                                                    return (
                                                                                        <>
                                                                                            {row.eventmemoid && (
                                                                                                <> - <b>{memoId}{row.eventmemoid}</b></>
                                                                                            )}
                                                                                            {row.eventinvoiceid && (
                                                                                                <> - <b>{invoiceId} {row.eventinvoiceid}</b></>
                                                                                            )}
                                                                                            {row.eventinventoryid && (
                                                                                                <> - <b>{inventoryId} {row.eventinventoryid}</b></>
                                                                                            )}
                                                                                        </>
                                                                                    );
                                                                                })()}

                                                                            </StyledTableCell>
)}

                                                                            </>
                                                                        );
                                                                    })}
                                                                </TableRow>
                                                            );
                                                        })}
                                                </>
                                            ) : (
                                                <TableCell colspan={12} style={{ textAlign: "center" }}>
                                                    <Typography variant="h6" className="color-BCBCBC">
                                                        No Records Found
                                                    </Typography>
                                                </TableCell>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 100]}
                                    component="div"
                                    count={data.length || 0}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </Grid>
                    )}
                </Grid>
            </Container>
        </div>
    );
};

const mapStateToProps = (state) => ({
    userDetails: state.Admin,
});

const mapDispatchToProps = (dispatch) => {
    return {
        getActivityList: (data, callback) =>
            dispatch(getActivityList(data, callback)),
            ownloadActivityLogs: (data, callback) =>
            downloadActivityLogs(data, callback), 
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActivityLogsComponent);
